export function getImageSrc(image: unknown) {
  if (!image) return undefined

  if (typeof image === 'string') {
    return image as string
  }
  if (typeof image === 'object' && 'src' in image) {
    return image.src as string
  }

  return undefined
}
